// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3824":"a4fa4bff5ce97f29","4470":"ce552d84f2940895","4721":"861810b32e20cb23","6345":"3a99007abcb84ef3"}[chunkId] + ".js";
};